<template>
    <div>
        <div v-if="!loading.display">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Quotation <strong> #{{data?data.code:null}}</strong> </h4>
                    <p class="text-subtitle-1">Edit Quotation</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
                    <!-- <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear> -->
            <v-row>
                <v-col>
                    <QuotationForm
                        v-model="data"
                        ref="form"
                        v-if="!loading.display"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn block color="primary" @click="handleSubmit" :loading="loading.submit">
                        <v-icon left >mdi-content-save</v-icon>
                        Save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block depressed @click="handleCancel">
                        Cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
                <v-row>
                    <v-col>
                        <v-skeleton-loader type="heading" class="my-4"/>
                        <v-skeleton-loader type="text" class="my-2"/>
                        <v-divider/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3">
                        <v-skeleton-loader type="text" class="my-2"/>
                    </v-col>
                    <v-col cols="3">
                        <v-skeleton-loader type="text" class="my-2"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-skeleton-loader type="text" class="my-2"/>
                    </v-col>
                    <v-col cols="4">
                        <v-skeleton-loader type="text" class="my-2"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-skeleton-loader type="text" class="my-2"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4">
                        <v-skeleton-loader type="text" class="my-2"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="3" >
                        <v-skeleton-loader type="button" />
                    </v-col>
                </v-row>
            </div>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
    </div>
</template>

<script>
import QuotationForm from './../../components/Sales/QuotationForm.vue'
import permissions from './../../data/permissions';
import PAlert from "./../../components/common/PAlert.vue"
import { mapActions } from 'vuex'
import authorize from '../../utils/authorize';
export default {    
    name: "QuotationEditView",
    components: {
        QuotationForm,
        PAlert
    },
    data() {
        return {
            data: null,
            loading: {
                display: false,
                submit: false
            },
            alert: {
                title: "",
                content: "",
                callback: null
            },
            perm: permissions
        }
    },
    methods: {
        ...mapActions("sales/quotation", ["storeQuotation", "fetchQuotation", "updateQuotation", "removeQuotation"]),
        ...mapActions({
            snackbar: "ui/snackbar/show"
        }),
        hasPermission(code) {
            return authorize(code)
        },
        handleSubmit() {
            this.alert = {
                content: "Are you sure you want to save!.",
                value: true,
                callback: this.submit
            }
        },
        async submit() {
            if(!this.$refs.form.validate()) return;
            this.loading.submit = true;
            await this.updateQuotation(this.data)
                .then(() => {
                    this.snackbar({ text: "Quotation Updated Succesfuly", color: "success" });
                    this.$router.replace({name: "QuotationDisplay", params: { id: this.data.id }})
                })
                .catch((error) => {
                    let message = error.response ? error.response.data.message : error;
                    this.snackbar({color: "error", message: message});
                }).finally(() => {
                    this.loading.submit = false
                })
        },
        fetchData() {
            this.loading.display = true
            this.fetchQuotation(this.$route.params.id).then(response => {
                this.data = this.prepareQuotation(response.data)
                this.loading.display = false
            }).catch((error) => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.loading.display = false;
            })
        },
        prepareQuotation(receipt) {
            return {
                    ...receipt,
                    lines: receipt.lines.map(line => {
                        return {
                            ...line,
                            key: Math.random()
                            
                        }
                    })
                }
        },
        handleCancel() {
            this.alert = { content: "Are you sure you want to cancel?", value: true, callback: this.cancel}
        },
        cancel() {
            this.$router.back()
        }
    },
    mounted() {
        this.form = {}
        this.fetchData()
    }

}
</script>

<style>

</style>